export type UserContextType = {
    givenName: string;
    setGivenName: (givenName: string) => void;
    surName: string;
    setSurname: (surname: string) => void;
    preferredName: string;
    setPreferredName: (preferredName: string) => void;
    pronouns: string;
    setPronouns: (pronouns: string) => void;
    avatar: string;
    setAvatar: (avatar: string) => void;
    avatarName: string;
    setAvatarName: (avatarName: string) => void;
};

export const UserContextDefaultValues: UserContextType = {
    givenName: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setGivenName: () => {},
    surName: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setSurname: () => {},
    preferredName: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setPreferredName: () => {},
    pronouns: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setPronouns: () => {},
    avatar: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setAvatar: () => {},
    avatarName: '',
    // biome-ignore lint/suspicious/noEmptyBlockStatements: inherited from operator
    setAvatarName: () => {},
};
